module.exports = __webpack_public_path__ + "img/cdz.afaea7b7.png";